import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import _isEmpty from 'lodash/isEmpty';
import Label from '../../../../atoms/Label';
import InfoBadge from '../../../../molecules/infoBadge';
import PropertyControlledComponent from '../../../../molecules/PropertyControlledComponent';
import styles from './fieldLabel.module.scss';
var FieldLabel = /*#__PURE__*/function (_PureComponent) {
  _inherits(FieldLabel, _PureComponent);
  var _super = _createSuper(FieldLabel);
  function FieldLabel() {
    _classCallCheck(this, FieldLabel);
    return _super.apply(this, arguments);
  }
  _createClass(FieldLabel, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        required = _this$props.required,
        label = _this$props.label,
        helpText = _this$props.helpText,
        fieldLabelClassName = _this$props.fieldLabelClassName,
        helpTextWidth = _this$props.helpTextWidth,
        labelClassName = _this$props.labelClassName,
        infoBadgeClassName = _this$props.infoBadgeClassName,
        highlightedLabel = _this$props.highlightedLabel,
        infoPlacement = _this$props.infoPlacement,
        infoContentClassName = _this$props.infoContentClassName,
        arrowPointAtCenter = _this$props.arrowPointAtCenter,
        infoIconClassName = _this$props.infoIconClassName;
      if (_isEmpty(label)) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: cx('fLC', styles.label, fieldLabelClassName)
      }, /*#__PURE__*/React.createElement(Label, {
        highlight: highlightedLabel,
        className: labelClassName
      }, label), /*#__PURE__*/React.createElement("span", {
        className: "required"
      }, required ? '*' : ''), /*#__PURE__*/React.createElement(PropertyControlledComponent, {
        controllerProperty: helpText
      }, /*#__PURE__*/React.createElement(InfoBadge, {
        infoBadgeClassName: cx(styles.infoBadge, infoBadgeClassName),
        infoContentClassName: cx(styles.infoContent, infoContentClassName),
        infoIconClassName: cx(styles.infoIcon, infoIconClassName),
        infoPlacement: infoPlacement,
        helpText: helpText,
        helpTextWidth: helpTextWidth,
        arrowPointAtCenter: arrowPointAtCenter
      })));
    }
  }]);
  return FieldLabel;
}(PureComponent);
FieldLabel.propTypes = {
  required: PropTypes.bool,
  label: PropTypes.string,
  helpTextWidth: PropTypes.string,
  labelClassName: PropTypes.string,
  infoBadgeClassName: PropTypes.string,
  helpText: PropTypes.string,
  fieldLabelClassName: PropTypes.string,
  highlightedLabel: PropTypes.bool,
  infoContentClassName: PropTypes.string,
  infoIconClassName: PropTypes.string,
  arrowPointAtCenter: PropTypes.bool,
  infoPlacement: PropTypes.string
};
FieldLabel.defaultProps = {
  required: false,
  label: undefined,
  helpTextWidth: undefined,
  infoBadgeClassName: undefined,
  labelClassName: undefined,
  helpText: undefined,
  fieldLabelClassName: undefined,
  highlightedLabel: false,
  infoContentClassName: undefined,
  infoIconClassName: undefined,
  arrowPointAtCenter: undefined,
  infoPlacement: undefined
};
export default FieldLabel;